import { TextField } from '@doordash/component-fields'
import { Text, Colors, Inset } from '@doordash/design-language'
import * as React from 'react'
import { connect } from 'react-redux'
import { getLocationFromZip } from '../../../api'
import {
  AU_ZIPCODE_PATTERNS,
  CA_ZIPCODE_PATTERNS,
  US_ZIPCODE_PATTERNS,
} from '../../../constants'
import * as events from '../../../events'
import { isValidZipCode } from '../../../utilities/validators'

import t from './strings'

type ZipFieldProps = {
  onChange?: any
  getLocation?: any
  error?: string
  trackSpaceEntry?: () => Promise<any>
  anchorId?: string
}

type ZipFieldStates = {
  address: string
  error: string
  value: string
  space: boolean
}

export class ZipField extends React.Component<ZipFieldProps, ZipFieldStates> {
  public static defaultProps = {
    onChange: console.log,
    getLocation: getLocationFromZip,
    trackSpaceEntry: console.log,
  }
  public constructor(props) {
    super(props)
    this.state = { address: '', error: '', value: '', space: false }
  }

  public removeSpaces = value => value.replace(' ', '')

  public getZipWithCountry = value => {
    let zipWithCountry = `${value} United States`
    if (AU_ZIPCODE_PATTERNS.test(value)) {
      zipWithCountry = `${value} Australia`
    } else if (CA_ZIPCODE_PATTERNS.test(value)) {
      zipWithCountry = `${value} Canada`
    }
    return zipWithCountry
  }

  public handleChange = async val => {
    // Tracking how often users enter spaces in the zipField
    // This is a major block for DA applicants and is placed to measure lift
    if (val.match(' ') && !this.state.space) {
      this.props.trackSpaceEntry()
      this.setState({ space: true })
    }
    const value = this.removeSpaces(val)

    this.setState({ value: this.removeSpaces(value) })
    this.props.onChange(value)
    if (!this.props.getLocation || !isValidZipCode(value)) {
      return this.setState({ address: '', error: '' })
    }

    if (this.props.getLocation && isValidZipCode(value)) {
      try {
        const zipWithCountry = this.getZipWithCountry(value)
        const address = await this.props.getLocation(zipWithCountry)
        let newAddress
        if (address) {
          newAddress = `${address.city}, ${address.state}`
          this.setState({ address: newAddress })
        } else {
          this.setState({ address: '' })
        }
      } catch (error) {
        this.setState({ address: '' })
      }
    }
  }
  public render() {
    return (
      <div>
        <div>
          <TextField
            {...this.props}
            placeholder={t.yourZipcode()}
            onChange={this.handleChange}
            autoComplete="postal-code"
            error={this.props.error || this.state.error}
            value={this.state.value}
            label={'zipcode'}
            isLabelHidden={true}
            data-anchor-id={this.props.anchorId}
          />
        </div>
        <Text
          styles={Text.Styles.Regular12}
          color={Colors.TextSecondary}
          lineHeight={Text.LineHeights.Medium}
        >
          <Inset size={Inset.Sizes.XxxSmall}>
            <div>{this.state.address}</div>
          </Inset>
        </Text>
      </div>
    )
  }
}

const mapDispatchToProps = {
  trackSpaceEntry: events.trackSpaceEntry,
}

export default connect(null, mapDispatchToProps)(ZipField)
